import { render, staticRenderFns } from "./historyItem.vue?vue&type=template&id=d878b29e&scoped=true&"
import script from "./historyItem.vue?vue&type=script&lang=js&"
export * from "./historyItem.vue?vue&type=script&lang=js&"
import style0 from "./historyItem.vue?vue&type=style&index=0&id=d878b29e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d878b29e",
  null
  
)

export default component.exports